'use strict';

(function ($) {
  var __REQUIRED_INFO = ['name', 'options'];

  function generateOption(option) {
    return '<option value="' + option.value + '">' + option.label + '</option>';
  }

  function generateSelector(settings) {
    settings = settings || {};

    __REQUIRED_INFO.forEach(function (key) {
      if (!settings[key]) {
        throw Error('[table-filter-select] No input ' + key + ' passed.');
      }
    });

    return '<select ' + 'name="' + settings.name + '" ' + 'id="' + (settings.id || settings.name) + '"> ' + settings.options.map(generateOption) + '</select>';
  }

  var SelectMaker = {
    init: function init(path, settings) {
      var select = $(generateSelector(settings));
      $(path).append(select);

      return select;
    },
    dataTablesColumnSearchHandler: function dataTablesColumnSearchHandler(column) {
      return function (event) {
        var text = $(event.currentTarget).val();
        column.search(text, false, false, true).draw();
      };
    }
  };

  window.SelectMaker = SelectMaker;
})(jQuery);